import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { formatCurrency } from "../../config/global";
import { setLoading } from "../../core/feature/config/configSlice";
import { getAllTopupHistory } from "../../core/service/api_topup";
import TabsMobile from "../__template/TabsMobileComponent";

const ComponentTopupHistory = () => {
  const [topupHistory, setTopupHistory] = useState<any>([]);

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [target, setTarget] = useState("topup");
  const dispatch = useDispatch();
  const location: any = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const getTopupHistory = async () => {
    dispatch(setLoading(true));
    getAllTopupHistory(0, size)
      .then((res: any) => {
        dispatch(setLoading(false));
        setTopupHistory(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreTopupHistory = async () => {
    setPage(page + 1);

    dispatch(setLoading(true));
    getAllTopupHistory(page + 1, size)
      .then((res) => {
        dispatch(setLoading(false));
        setTopupHistory(topupHistory.concat(res.data.content));
        console.log(res.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const currentSizeTopupHistory = useMemo(() => {
    const a = topupHistory.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [topupHistory]);
  useEffect(() => {
    if (location.state) {
      setTarget(location.state.target);
    }
    getTopupHistory();
  }, []);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
        <TabsMobile
          name={`${t("TOPUP-HISTORY.title")}`}
          backUrl={target == "topup" ? "topup" : "home"}
        ></TabsMobile>
      </div>
      {topupHistory.length < 1 ? (
        <div className="flex justify-center">
          <span className="font-normal text-xs text-center">
            data tidak ditemukan
          </span>
        </div>
      ) : (
        <div className="px-4 pb-3 pt-3 flex flex-col gap-2.5 top-to-bottom">
          {topupHistory.map((res: any) => (
            <div className="bg-white shadow-md rounded-xl p-3 border-l-8 border-l-emerald-500">
              <div className="flex flex-row items-center">
                <div className="flex flex-col grow gap-2">
                  <span className="font-normal text-xs text-psp-gray">
                    {moment(res.dateTime).format("LL")}
                  </span>
                  <h1 className="m-0 font-bold text-xs  text-psp-gray">
                    {res.name}{" "}
                    <span className="font-medium text-xs">
                      {res.callerName}
                    </span>
                  </h1>
                </div>
                <div className="flex-0 flex-col flex">
                  <span className="font-normal text-sm text-right  text-psp-gray">
                    Saldo
                  </span>
                  <h1 className="m-0 font-bold text-sm text-emerald-500">
                    {formatCurrency(res.amount)}
                  </h1>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {currentSizeTopupHistory < 10 ? (
        ""
      ) : (
        <div className="flex w-full pb-3">
          <button
            onClick={addMoreTopupHistory}
            className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
          >
            {t("OTHER.showMore")}
          </button>
        </div>
      )}
    </div>
  );
};

export default ComponentTopupHistory;
